<template>
    <div class="clients">
        <div class="pageContent">
            <heading-wrap>
                <span slot="title">Clients Dashboard</span>
            </heading-wrap>
            <Spinner v-if="loading"/>
            <form-group>
                <input :max="new Date().toISOString().slice(0, 10)" title="Start Date" v-model="form.from" @change="callApi" type="date" :style="{maxWidth: '10%', marginBottom: '1rem'}" class="form-control col-md-5 mr-sm-2" />
            </form-group>
            <form-group>
                <input :max="new Date().toISOString().slice(0, 10)" title="End Date" v-model="form.to" @change="callApi" type="date" :style="{maxWidth: '10%', marginBottom: '1rem', marginLeft: '1rem'}" class="form-control col-md-5 mr-sm-2" />
            </form-group>
            <slot-table :data="tableData()" :columns="columns">
                <template slot="tier" slot-scope="props">
                    <th>
                    <span class="text-uppercase table__cursor-pointer">{{props.item.tier}}</span>
                    </th>
                </template>
                <template slot="download_counter" slot-scope="props">
                    <span class="text-uppercase">{{props.item.download_counter}}</span>
                </template>
                <template slot="renders_counter" slot-scope="props">
                    <span class="text-uppercase">{{props.item.renders_counter}}</span>
                </template>
                <template slot="adtag_create_counter" slot-scope="props">
                    <span class="text-uppercase">{{props.item.adtag_create_counter}}</span>
                </template>
                <template slot="adtag_refresh_counter" slot-scope="props">
                    <span class="text-uppercase">{{props.item.adtag_refresh_counter}}</span>
                </template>
        </slot-table>
        </div>
    </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import SlotTable from '@/components/Table/table'
import {clientMixin} from '@/mixins/clientMixin'
import {modalMixin} from '@/mixins/modalMixin'
import Spinner from '@/components/SpinnerIcon/spinner.vue'

export default {
  name: 'Clients',
  mixins: [clientMixin, modalMixin],
  components: {
    HeadingWrap,
    SlotTable,
    Spinner
  },
  mounted () {
    this.callApi()
  },
  methods: {
    callApi () {
      this.startLoading()
      this.getClientStats(this.form).then(() => {
        this.finishLoading()
      })
    },
    tableData () {
      return [
        {
          tier: 'T1',
          download_counter: this.stats.stats.t1_download_count,
          renders_counter: this.stats.stats.t1_render_count,
          adtag_create_counter: this.stats.stats.t1_ad_tag_create_count,
          adtag_refresh_counter: this.stats.stats.t1_ad_tag_refresh_count
        },
        {
          tier: 'T2',
          download_counter: this.stats.stats.t2_download_count,
          renders_counter: this.stats.stats.t2_render_count,
          adtag_create_counter: this.stats.stats.t2_ad_tag_create_count,
          adtag_refresh_counter: this.stats.stats.t2_ad_tag_refresh_count
        }
      ]
    }
  },
  data () {
    return {
      columns: {
        tier: 'Tier',
        download_counter: 'Downloads Count',
        renders_counter: 'Renders Count',
        adtag_create_counter: 'Ad Tag Create Count',
        adtag_refresh_counter: 'Ad Tag Refresh Count'
      },
      form: {
        to: new Date().toISOString().slice(0, 10),
        from: '',
        id: this.$route.params.id
      }
    }
  }
}
</script>

<style lang="scss">
  hr {
    border: 0;
    height: 1px;
    background:rgb(125, 119, 119);
    background-image: linear-gradient(to right, #ccc, rgb(125, 119, 119), #ccc);
  }
  .clients {
    &__logo {
      display: flex;
      align-items: center;
      .clientLogo {
        margin-right: 10px;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/client/client-dashboard.vue